import { api } from '@/api';

export interface PostEventChatAbandonedRequest {
  chatId: string;
}

const eventChatAbandonedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postEventChatAbandoned: builder.mutation<void, PostEventChatAbandonedRequest>({
      query: ({ chatId }) => ({
        url: '/event/chat/abandoned',
        method: 'POST',
        body: { chatId },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostEventChatAbandonedMutation } = eventChatAbandonedApi;
